import { render, staticRenderFns } from "./InstrumentName.vue?vue&type=template&id=dabb2a62&scoped=true"
import script from "./InstrumentName.vue?vue&type=script&lang=ts"
export * from "./InstrumentName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabb2a62",
  null
  
)

export default component.exports